/**
 * Collects distinct field names referenced across a config's rules, in
 * first-seen order. Generic across transformer types — each caller supplies
 * its own rule shape via fieldExtractor (a single field name, e.g. Row
 * Extractor's sourceColumn, or an array of names, e.g. Column Cleaner's
 * fields) rather than this function assuming one shape.
 */
export function collectDistinctSourceFields(
  rules: any[] | null | undefined,
  fieldExtractor: (rule: any) => string | string[] | null | undefined,
): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const rule of rules ?? []) {
    const value = fieldExtractor(rule);
    const names = Array.isArray(value) ? value : (value ? [value] : []);
    for (const name of names) {
      if (name && !seen.has(name)) {
        seen.add(name);
        result.push(name);
      }
    }
  }
  return result;
}
